export interface SessionTokensState {
  idToken: string | null;
  accessToken: string | null;
  refreshToken: string | null;
}

export type SessionTokenPayload = {
  idToken?: string | null;
  accessToken?: string | null;
  refreshToken?: string | null;
};

export function createEmptySessionTokensState(): SessionTokensState {
  return {
    idToken: null,
    accessToken: null,
    refreshToken: null,
  };
}

export function applySessionTokenPayload(
  state: SessionTokensState,
  payload: SessionTokenPayload
): void {
  if (payload.idToken !== undefined) {
    state.idToken = payload.idToken;
  }

  if (payload.accessToken !== undefined) {
    state.accessToken = payload.accessToken;
  }

  if (payload.refreshToken !== undefined) {
    state.refreshToken = payload.refreshToken;
  }
}
